<template>
  <div class="countdown">
    <Load v-if="isLoading" />
    <template v-else>
      <!-- 
        TODO: Hide campaign name
        <v-row justify="center" no-gutters>
        <v-col class="text-center">
          <h1>{{ campaignName }}</h1>
        </v-col>
      </v-row> -->

      <v-row
        v-if="timeLeft > -1"
        class="mt-8 pt-4"
        justify="center"
        no-gutters
      >
        <h2>Start in</h2>
      </v-row>
      <v-row
        v-if="timeLeft > -1"
        class="mt-10"
        justify="center"
        no-gutters
      >
        <CountDown
          v-if="timeLeft > -1"
          :timeLeft="timeLeft"
          @end="onEndCountdown"
        />
      </v-row>
      <v-row
        v-if="innerHtml"
        class="mt-8 items-center"
        justify="center"
        no-gutters
      >
        <v-col cols="auto" class="pb-8">
          <Button
            block
            color="color-bnn"
            height="48px"
            depressed
            v-if="timeLeft < 0"
            @click="toProductDetail"
            :title="`เข้าสู่การจอง ${campaignName}`"
          />
        </v-col>
        <div class="w-full"></div>
        <div v-html="innerHtml" class="html-content"></div>
      </v-row>
    </template>
  </div>
</template>

<script>
import loadCampaign from '../utils/loadcampaign'
import Load from './Load'
import CountDown from '@/components/bnn/CountDown'
import Button from '@/components/bnn/Button'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      modelLoading: state => state.model.isLoading,
      isLoaded: state => state.model.isLoaded,
      campaign: state => state.campaign.current,
      campaignData: state => state.campaign.data,
      campaignLoading: state => state.campaign.isLoading,
      startTime: state =>
        state?.campaign?.current?.data?.started_at_timestamp ||
        undefined,
      currentTime: state =>
        state?.campaign?.current?.data?.current_datetime_timestamp ||
        undefined,
    }),

    isLoading() {
      return this.campaignLoading || this.modelLoading
    },

    innerHtml() {
      if (this.isCountdownEnd) {
        return this.campaign?.data?.html_after_start
      }
      return this.campaign?.data?.countdown_html
    },

    htmlAfterStart() {
      return this.campaign?.data?.html_after_start
    },

    timeLeft() {
      if (this.startTime && this.currentTime) {
        return (this.startTime - this.currentTime) * 1000
      }
      return -1
    },

    campaignName() {
      return this.campaign?.data?.name
    },

    countDownHtml() {
      return this.campaign?.data?.countdown_html
    },

    slug() {
      return this.campaign?.data?.slug
    },
  },

  data() {
    return {
      isCountdownEnd: false,
    }
  },

  watch: {
    timeLeft(val) {
      if (val <= 0) {
        this.onEndCountdown()
      }
    },
  },

  async mounted() {
    const active = await loadCampaign(this.campaign)
    if (active) {
      document.body.style.overflowY = ''
      document.querySelector('html').style.overflowY = ''
    }

    if (this.campaign?.data?.redirect_url) {
      window.location.href = this.campaign?.data?.redirect_url
    }
  },

  methods: {
    onEndCountdown() {
      this.isCountdownEnd = true
      if (!this.htmlAfterStart) {
        setTimeout(async () => {
          this.$router
            .push({
              name: 'ProductDetail',
              params: {
                slug: this.slug,
              },
            })
            .catch(() => true)
        }, 300)
      }
    },

    toProductDetail() {
      this.$router
        .push({
          name: 'ProductDetail',
          params: {
            slug: this.slug,
          },
        })
        .catch(() => true)
    },
  },

  components: {
    Load,
    CountDown,
    Button,
  },
}
</script>

<style lang="stylus" scoped>

.countdown {
  margin-top: 80px;
  height: 100%
  min-height: 100vh
}

.html-content
  width: 100%

.btn-bnn-default
  padding: 0 1.25rem !important
  font-size: 1rem !important
</style>
